import { FloormapConfig } from 'features/editor'
import { useEffect } from 'react'

type UsePopulateFloorMapProps = {
	isSuccess: boolean
	data: FloormapConfig | undefined
	setData: (data: FloormapConfig) => void
}

export const usePopulateFloorMap = ({ isSuccess, data, setData }: UsePopulateFloorMapProps) => {
	useEffect(() => {
		if (isSuccess && data) {
			Array.isArray(data) ? setData(data) : setData([])
		}
	}, [data, isSuccess])
}
